import React from 'react'
import ReactDOM from 'react-dom/client'
import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import Swipeable from 'react-swipeable'
import Mixpanel from '../common/mixpanel'

import Loader from '../common/components/loading'

import $ from 'jquery'

declare global {
  interface Window {
    showPropertyGallery: () => void
    property_gallery: any
  }
}

window.showPropertyGallery = () => {
  if ($('#property-gallery').length && window.property_gallery.length > 0) {
    const $gallery = $('#property-gallery')
    
    Mixpanel.track('View Property Gallery', {
      name: $gallery.data('name')
    })

    // Disable scrolling
    $('body').css('overflow-y', 'hidden')

    const root = ReactDOM.createRoot($gallery[0]);

    root.render(
      <Gallery name={$gallery.data('name')} guest={$gallery.data('guest')} images={window.property_gallery} requestClose={() => {
        root.unmount();
        $('body').css('overflow-y', 'auto');
      }} />
    )
  }
}

interface GalleryImageProps {
  image: string
  caption: string
  guest_limit?: boolean
}

interface GalleryImageState {
  loading: boolean
}

class GalleryImage extends React.Component<GalleryImageProps, GalleryImageState> {
  static get defaultProps() {
    return {
      image: "",
      caption: ""
    }
  }

  constructor(props) {
    super(props)

    this.handleImageLoaded = this.handleImageLoaded.bind(this)
    
    this.state = {
      loading: true
    }
  }

  handleImageLoaded() {
    this.setState({
      loading: false
    })
  }

  restrictedOverlay() {
    return (
      <div className="guest-restricted-box">
        <p><i className="fa fa-lock"></i></p>
        <p>
          Become a Member to view the full gallery<br />
          <a href="/join" className="button primary mg-b-none mg-s-t">Join Now</a>
        </p>
      </div>
    )
  }

  render() {
    const { loading } = this.state

    return (
      <div className={"gallery-image " + (this.props.guest_limit ? "gallery-image__guest-limit" : "")}>
        <img src={this.props.image} onLoad={this.handleImageLoaded} />

        { loading ? <Loader /> : undefined }

        { this.props.guest_limit ? this.restrictedOverlay() : undefined }
      </div>
    )
  }
}

interface GalleryProps {
  name: string
  guest?: boolean
  images: any[]
  requestClose: () => void
}

interface GalleryState {
  index: number
  direction: string
  caption: string
  canvasWidth: number
  canvasHeight: number
}

class Gallery extends React.Component<GalleryProps, GalleryState> {
  constructor(props) {
    super(props)

    this.state = {
      index: 0,
      direction: 'right',
      caption: '',
      canvasWidth: 1024,
      canvasHeight: 768
    }

    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.handleKeyPress = this.handleKeyPress.bind(this)
  }

  static get defaultProps() {
    return {
      images: [],
      requestClose: () => {}
    }
  }

  nextSlide() {
    this.setState({
      index: Math.min(this.props.images.length - 1, this.state.index + 1),
      direction: 'right'
    })
  }

  prevSlide() {
    this.setState({
      index: Math.max(0, this.state.index - 1),
      direction: 'left'
    })
  }

  handleKeyPress(e) {
    console.log(e.key)

    if (e.key == 'ArrowLeft') {
      this.prevSlide()
    }

    if (e.key == 'ArrowRight') {
      this.nextSlide()
    }
  }

  updateDimensions() {
    const sceneWidth = document.documentElement.clientWidth
    const sceneHeight = document.documentElement.clientHeight

    this.setState({
      canvasWidth: sceneWidth - 100,
      canvasHeight: sceneHeight - 76 - 64 - 30
    })
  }

  componentDidMount() {
    this.updateDimensions()
    window.addEventListener("resize", this.updateDimensions.bind(this))

    const canvas = this.refs.canvas as any
    canvas.focus()
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this))
  }

  render() {
    const { canvasWidth, canvasHeight, direction } = this.state

    const currentSlide = this.props.images[this.state.index]
    const caption = currentSlide.caption

    let guest_obscured = this.props.guest && this.state.index >= 5

    return (
      <div className="gallery-viewer">
        <div className="gallery-header">
          <div className="white-logo"></div>

          <div className="gallery-close" onClick={this.props.requestClose}>
            CLOSE <span className="icon icon-close-l"></span>
          </div>
        </div>

        <div className="gallery-control gallery-prev" onClick={this.prevSlide} onKeyDown={this.handleKeyPress}></div>

        <Swipeable onSwipedLeft={this.nextSlide} onSwipedRight={this.prevSlide}>
          <div ref="canvas" tabIndex={0} onKeyDown={this.handleKeyPress} className="gallery-canvas" style={{ width: canvasWidth, height: canvasHeight }}>
            <ReactCSSTransitionGroup
              transitionName={`gallery-${direction}`}
              transitionEnterTimeout={400}
              transitionLeaveTimeout={400}
            >
              <GalleryImage key={this.state.index} guest_limit={guest_obscured} {...currentSlide} />
            </ReactCSSTransitionGroup>
          </div>
        </Swipeable>

        <div className="gallery-control gallery-next" onClick={this.nextSlide} onKeyDown={this.handleKeyPress}></div>

        <div className="gallery-footer">
          { caption && caption.length > 0 ? <p>{ caption }</p> : <p></p> }
          { this.state.index + 1} / { this.props.images.length }<br />
          { this.props.name }
        </div>
      </div>
    )
  }
}